import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthService) {}

  // 최고관리자라면 대시보드로 탁송관리자라면 오늘의 실시간 탁송의뢰로 이동
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const uid = await this.auth.uid();
    let isLoggedIn = !!uid;

    if (isLoggedIn) {
      let isLoggedIn = !!uid;
      if (uid !== 'gnns7b0xoBaqrO68de9GWLmaJfw2') {
        setTimeout(() => {
          this.router.navigateByUrl('/today-request');
        }, 500);
      }
      return isLoggedIn;
    } else {
      this.router.navigateByUrl('/account/login');
      return false;
    }
  }
}
